import Layout from '@/pages/_layout';
import PageView from '@/pages/PageView';
import DeployMenu from '@/pages/deployMenu';
import HelpDoc from '@/pages/helpDoc';
import Dashboard from './pages/dashboard';
import DeployCarousel from './pages/deployCarousel';
import CreateOrEditCarousel from './pages/deployCarousel/createOrEdit';
import Welcome from './pages/welcome';
export default {
    routes: [
        {
            path: '/',
            component: Layout,
            children: [
                { path: '', redirect: '/dashboard' },
                { path: 'deployMenu', component: DeployMenu },
                { path: 'helpDoc', component: HelpDoc },
                { path: 'dashboard', component: Dashboard },
                { path: 'deployCarousel', component: DeployCarousel },
                {
                    path: 'deployCarousel/createOrEdit',
                    component: CreateOrEditCarousel,
                },
                { path: 'welcome', component: Welcome },
                { path: '*', component: PageView },
            ],
        },
    ],
};
